
import { Capacitor } from '@capacitor/core';

class Platform {

    static isMobile() {
        return Capacitor.isNativePlatform();
    }

    static isIos() {
        return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
    }

}

export default Platform;
